/**
 * Orca Runners route — eagerly registers the route + `beforeLoad` SSR loader and
 * the `?container=` search contract, but defers the component + atom imports via
 * `.lazy.tsx`, so the orca-admin chunk stays out of the bundle for non-admins on
 * every other route.
 *
 * The eager file may import NO atoms/components/design modules (bundle budgets):
 * `validateRunnersSearch` lives in the pure `~/lib/orca-runners-search.ts`, and
 * the v5 frame's stylesheet is linked from {@link runnersHead} via the pure
 * `~/lib/orcaloops-head.ts` (web CLAUDE.md rule 6).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { validateRunnersSearch } from "~/lib/orca-runners-search.ts";
import { orcaRunnersBeforeLoad } from "~/lib/orca-ssr.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * The page's head: the orcaloops frame stylesheet, render-blocking, so the SSR
 * markup paints styled.
 *
 * @since 1.0.0
 */
export const runnersHead = () => ({ links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/runners")({
  beforeLoad: orcaRunnersBeforeLoad,
  head: runnersHead,
  validateSearch: validateRunnersSearch,
});
